export default "__VITE_ASSET__23160183__"